import * as React from 'react';

const Evaluation: React.FC<{}> = () => {
  return <></>;
};

export default Evaluation;
